import './index.scss';
import classnames from 'classnames';
import React from 'react';
import AccordionCollapse from './accordion_collapse';
import AccordionToggle from './accordion_toggle';
import SingleItem from './single_item';
const ClauseItem = ({ accordionRef, activeClauseIds, anchorClauses, classificationName, comparatorClauses, documents, setActiveClauseIds, selectedName, setSelectedName, }) => {
    const defaultClauses = [];
    if (anchorClauses.length > 0)
        defaultClauses.push(anchorClauses[0]);
    if (comparatorClauses.length > 0)
        defaultClauses.push(comparatorClauses[0]);
    const isToggled = selectedName === classificationName;
    const onClickClauseSection = () => {
        var _a, _b;
        if (!isToggled) {
            setActiveClauseIds({
                anchorClause: (_a = anchorClauses[0]) === null || _a === void 0 ? void 0 : _a.id,
                comparatorClause: (_b = comparatorClauses[0]) === null || _b === void 0 ? void 0 : _b.id,
            });
            setSelectedName(classificationName);
            return;
        }
        setActiveClauseIds({ anchorClause: undefined, comparatorClause: undefined });
        setSelectedName('');
    };
    const shouldShowExpandedView = anchorClauses.length > 1 || comparatorClauses.length > 1 || !!(anchorClauses.length &&
        comparatorClauses.length &&
        anchorClauses[0].name !== comparatorClauses[0].name);
    const accordionClass = classnames('clause-accordion-section', {
        selected: isToggled,
        single: !shouldShowExpandedView,
    });
    return (React.createElement("div", { className: accordionClass, onClick: !isToggled ? onClickClauseSection : undefined },
        shouldShowExpandedView &&
            React.createElement(React.Fragment, null,
                React.createElement(AccordionToggle, { documents: documents, clause: defaultClauses === null || defaultClauses === void 0 ? void 0 : defaultClauses[0], classificationName: classificationName, anchorClauses: anchorClauses, comparatorClauses: comparatorClauses, isToggled: isToggled, onClickClauseSection: isToggled ? onClickClauseSection : undefined, accordionRef: accordionRef }),
                React.createElement(AccordionCollapse, { classificationName: classificationName, anchorClauses: anchorClauses, comparatorClauses: comparatorClauses, activeClauseIds: activeClauseIds, setActiveClauseIds: setActiveClauseIds })),
        !shouldShowExpandedView &&
            React.createElement(SingleItem, { documents: documents, clause: defaultClauses === null || defaultClauses === void 0 ? void 0 : defaultClauses[0], classificationName: classificationName, anchorClauses: anchorClauses, comparatorClauses: comparatorClauses, isToggled: isToggled, onClickClauseSection: isToggled ? onClickClauseSection : undefined })));
};
export default ClauseItem;
